export const AUTH_STORAGE_KEY = 'kh.auth.session';

export const LEGACY_AUTH_STORAGE_KEYS = {
  ACCESS_TOKEN: 'accessToken',
  SCHOOL_AUTH_DATA: 'KH.AuthData',
  USER_CLAIMS: 'userClaims',
  NOVA_SDK_ACCESS_TOKEN: 'nova-sdk-access-token'
} as const;
